import type { RawButtonProps } from '@ps/web-shared-components';
import { StarsButton as Button } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Tournament } from '../../../../../types/MTT';

import { TXTCLI_Lobby } from './LobbyButton.messages.json';
import styles from './LobbyButton.scss';

interface LobbyButtonProps {
  tournament: Tournament;
  className?: string;
  size?: RawButtonProps['size'];
}

const LobbyButton: React.FC<LobbyButtonProps> = ({ tournament, className, size = 'small' }) => {
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);

  const handleLobbyButtonClick = () => {
    if (isEmbedded) window.starsweb?.app?.execute(`tournament/${tournament?.id}`);
  };

  return (
    <Button
      translation={TXTCLI_Lobby}
      size={size}
      onClick={handleLobbyButtonClick}
      className={classNames(styles.root, className || '')}
    />
  );
};

export default LobbyButton;
